module.exports = __webpack_public_path__ + "static/media/board.9ca11dc5.svg";